<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/expense.webp"
  >
    <ng-container i18n
      >Expenses track costs related to property management, such as repairs or service fees. Actions include creating,
      approving, and paying expenses, as well as notifying the relevant parties like the guest or user. Proper expense
      management ensures financial oversight and timely payment processing.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when an expense is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.ExpenseCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExpenseCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ExpenseApproved)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExpenseApproved ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Approved
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ExpenseDenied)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExpenseDenied ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Denied
        </button>
        <!--        <button-->
        <!--          type="button"-->
        <!--          (click)="onSelectEvent(events.ExpenseDeleted)"-->
        <!--          class="btn btn-sm"-->
        <!--          [ngClass]="selectedEvent === events.ExpenseDeleted ? 'btn-info' : 'btn-outline-light'"-->
        <!--        >-->
        <!--          Deleted-->
        <!--        </button>-->
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.ExpenseCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ExpenseApproved" [ngTemplateOutlet]="approvedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ExpenseDenied" [ngTemplateOutlet]="deniedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ExpenseDeleted" [ngTemplateOutlet]="deletedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Expense is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Expense is Approved</h6>
    <ng-template [ngTemplateOutlet]="approvedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Expense is Denied</h6>
    <ng-template [ngTemplateOutlet]="deniedEvent"></ng-template>
  </div>
  <!--  <div class="container-box shadow">-->
  <!--    <h6 class="text-uppercase m-0 px-3 py-2">Expense is Deleted</h6>-->
  <!--    <ng-template [ngTemplateOutlet]="deletedEvent"></ng-template>-->
  <!--  </div>-->
</div>

<ng-template #createdEvent>
  <app-notify-handler-automation
    [event]="events.ExpenseCreated"
    [handler]="eventHandlers.ExpenseNotifyGuestHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of the expense"
    [messageSubject]="guestNotificationMessages[events.ExpenseCreated].subject"
    [messageBody]="guestNotificationMessages[events.ExpenseCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-handler-automation>

  <app-notify-users-automation
    [event]="events.ExpenseCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of the expense"
    [messageSubject]="userNotificationMessages[events.ExpenseCreated].subject"
    [messageBody]="userNotificationMessages[events.ExpenseCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <div class="panel active" *ngIf="viewType !== 'table'">
    <mat-form-field2>
      <mat-label i18n>Approve the expense if it is not bigger than X</mat-label>
      <input matInput [formControl]="autoApproveAmountCtrl" required />
      <mat-error *ngIf="autoApproveAmountCtrl.touched && autoApproveAmountCtrl.hasError('required')" i18n>
        Amount is required
      </mat-error>
    </mat-form-field2>
  </div>
  <app-do-action-automation
    [event]="events.ExpenseCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when expense created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #approvedEvent>
  <app-do-action-automation
    [event]="events.ExpenseApproved"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.ExpenseMarkPaidHandler"
    i18n-label
    i18n-name
    label="Set the status to paid"
    name="Mark the expense as paid when expense approved"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-users-automation
    [event]="events.ExpenseApproved"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of expense approved"
    [messageSubject]="userNotificationMessages[events.ExpenseApproved].subject"
    [messageBody]="userNotificationMessages[events.ExpenseApproved].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-do-action-automation
    [event]="events.ExpenseApproved"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when expense approved"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #deniedEvent>
  <app-do-action-automation
    [event]="events.ExpenseDenied"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.ExpenseMarkUnpaidHandler"
    i18n-label
    i18n-name
    label="Set the status to unpaid"
    name="Mark the expense as unpaid when expense denied"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-users-automation
    [event]="events.ExpenseDenied"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of expense denied"
    [messageSubject]="userNotificationMessages[events.ExpenseDenied].subject"
    [messageBody]="userNotificationMessages[events.ExpenseDenied].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-do-action-automation
    [event]="events.ExpenseDenied"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when expense denied"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #deletedEvent>
  <app-notify-users-automation
    [event]="events.ExpenseDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of expense deleted"
    [messageSubject]="userNotificationMessages[events.ExpenseDeleted].subject"
    [messageBody]="userNotificationMessages[events.ExpenseDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-do-action-automation
    [event]="events.ExpenseDeleted"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when expense deleted"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>
